import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class NavigationService {
    goTo(url: string): void {
        window.location.href = url;
    }
}
